import React, {useState, useEffect} from 'react'
import {useLocation, useHistory} from 'react-router-dom'
import {getAllNews, getProjects} from "../../services";
import {NewsList, PageHeader} from "../../components";
import {projectsWithNews} from "../../util";

const News = () => {
    const [allNews, setAllNews] = useState([]);
    const [displayNews, setDisplayNews] = useState([]);
    const [project, setProject] = useState(0);
    const [projects, setProjects] = useState([]);
    const [projectSelect, setProjectSelect] = useState([])

    const location = useLocation()
    const history = useHistory()

    const changeProject = (event) => {
        history.push(`/news?project=${event.target.value}`)
    }

    useEffect( () => {
        getAllNews()
            .then( (response) => setAllNews(response.data))
    }, [])

    useEffect( () => {
        const projectId = new URLSearchParams(location.search).get("project")
        if ( projectId !== null ) {
            setProject(parseInt(projectId))
        } else {
            setProject(0)
        }
    }, [location])

    useEffect(() => {
        if ( project === 0 ) {
            setDisplayNews(allNews)
        } else {
            setDisplayNews(
                allNews.filter(item => item.projectId === project)
            )
        }
    }, [allNews,project])

    useEffect( () => {
        getProjects()
            .then( (response) => setProjects(response.data))
    }, [])

    useEffect( () => {
        let projectSelectTemp = projectsWithNews(projects)
            .sort((a,b) => {
                return a.name.localeCompare(b.name)
            })
            .map( (item) => {
                return (
                    <option key={item.id} value={item.id}>{item.name}</option>
                )
            })
        projectSelectTemp.unshift(<option key={0} value={0}>All projects</option>)
        setProjectSelect(projectSelectTemp)
    }, [projects])

    return (
        <div className="container">
            <PageHeader title="News" />
            <select className="mb-3" value={project} onChange={changeProject}>
                {projectSelect}
            </select>
            <NewsList allNews={displayNews} projects={projects} projectId={project}/>
        </div>
    )
}

export default News
